/** A UUID has five hyphen-separated hex groups and no meaning to a reader. */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * A tag as something a human can recognise.
 *
 * Stripping up to the first hyphen removes the site prefix on sites that use
 * one — `longridge-01-PIT-DWT614A` → `01-PIT-DWT614A`. On a site that keys
 * datapoints by bare UUID it removed the first hex group instead, so the chips
 * read `4ec7-491f-b289-46e6ea430b45`: not just ugly, actively misleading, since
 * that is not the tag's id. A description is what identifies such a tag anyway.
 */
export const chipLabel = (tag: {
  id: string
  description?: string
  name?: string
}): string => {
  const label = tag.description?.trim() || tag.name?.trim()
  if (UUID.test(tag.id)) return label || tag.id.slice(0, 8)
  return label && label.length <= 48 ? label : tag.id.replace(/^[^-]*-/, '')
}

/** A tag with only its id to go on: same site-prefix and UUID handling. */
export const shortTag = (id: string): string =>
  UUID.test(id) ? id.slice(0, 8) : id.replace(/^[^-]*-/, '')
